import React from "react";

import { recordItem } from "../../../../types";
import moment from "moment";

import "./index.scss";

interface PropsType {
  content: recordItem;
  firstItem: boolean;
  lastItem: boolean;
}

export default function ServiceProgressItemV2(props: PropsType) {
  const { content, firstItem, lastItem } = props;
  return (
    <div className="progress-wrapper">
      <div className={`top ${firstItem ? "" : "firstTop"}`}>
        <div className="header-field">
          <h3>{content?.subOrderStatusText}</h3>
          {content?.createTime && (
            <div className="create-time">
              {moment(content?.createTime).format("MM/DD HH:mm")}
            </div>
          )}
        </div>
        {content?.phone && (
          <div className="phone">
            <a href={"tel:" + content?.phone}>联系司机</a>
          </div>
        )}
      </div>

      <div className={`content-area ${lastItem ? "last-content-area" : ""}`}>
        {content.tips && <div className="tip">{content.tips}</div>}
      </div>
    </div>
  );
}
